import React, {Component} from "react";
import {connect} from "react-redux";
import {Avatar, Popover} from "antd";
import {userSignOut} from "appRedux/actions/Auth";
import { Auth } from 'aws-amplify';

class UserProfile extends Component {

  userSignOut = () => {
    const { userSignOut } = this.props
    this.signOut()
    userSignOut()
  }

  async  signOut () {
    try {
        await Auth.signOut();
    } catch (error) {
        console.log('error signing out: ', error);
    }
  } 

  render() {
    const {username} = this.props;

    const userMenuOptions = (
      <ul className="gx-user-popover">
        <li onClick={this.userSignOut}>Logout
        </li>
      </ul>
    );

    return (

      <div className="gx-flex-row gx-align-items-center gx-avatar-row">
        <Popover placement="bottomRight" content={userMenuOptions} trigger="click">
          <Avatar className="gx-mr-2" style={{backgroundColor: '#ff876e'}} icon="user"/>
          <span className="gx-avatar-name">{username ? username : "Loading"}<i
            className="icon icon-chevron-down gx-fs-xxs gx-ml-2"/></span>
        </Popover>
      </div>

    )

  }
}

const mapStateToProps = ({auth}) => {
  const {username} = auth;
  return {username}
};

export default connect(mapStateToProps, {userSignOut})(UserProfile);
